import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/whistles/amaranth-d-tun.jpg'


const _hoisted_1 = {
  style: {"margin-top":"5em"},
  id: "prices"
}
const _hoisted_2 = { class: "container text-center mb-2 w-75" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-muted text-center" }, "prices", -1)
const _hoisted_4 = { class: "bg-info" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p class=\"bg-info\"> All prices quoted are final prices plus delivery/shipping costs. Due to the small business status according to German § 19 UStG we do not charge sales tax and therefore do not show it. </p><img src=\"" + _imports_0 + "\" class=\"w-50 pb-4 pt-2\" alt=\"Whistle in D made from amaranth wood.\" title=\"Whistle in D made from amaranth wood.\"><h3 class=\"text-muted text-center\">standard whistles</h3><p> Prices are for a standard whistle where I decide on tube diameter, wall thickness, hole size &amp; position etc. </p><p> All whistles are tuned in <b>just intonation</b>. If some other tuning makes you happier, let me know when ordering. </p><p> Though I didn&#39;t want to blow up the table with too many rows I <em>do</em> make whistles in <b>all keys</b>, if requested. </p>", 6)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "african ebony", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" NB: I cannot sell whistles made from "),
  /*#__PURE__*/_createElementVNode("b", null, "CITES"),
  /*#__PURE__*/_createTextVNode(" protected woods (though, of course, legally acquired) outside the EU. ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "About the holes"),
  /*#__PURE__*/_createTextVNode(": If not asked to do otherwise, I do not make "),
  /*#__PURE__*/_createElementVNode("b", null, "circular"),
  /*#__PURE__*/_createTextVNode(" holes but use an oval hole shape as I only see advantages there. If you wish the holes to be circular, please notify me when ordering. ")
], -1)
const _hoisted_14 = { class: "table table-striped" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-dark" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Key"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Aluminium"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Brass/Wood"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Wood")
  ])
], -1)
const _hoisted_16 = { scope: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode(" I do not have any online shop functionality here, so if you want to order something, just "),
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "contact me"
        }),
        _createTextVNode(" . ")
      ]),
      _hoisted_5,
      _createElementVNode("p", null, [
        _createTextVNode(" A standard wooden whistle is made from "),
        _hoisted_11,
        _createTextVNode(" or some equivalent wood. I enjoy using other wood sorts as well, "),
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "please contact me"
        }),
        _createTextVNode(" for options. Depending on the sort there may be a surcharge. ")
      ]),
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("table", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardItems, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.key,
              class: _normalizeClass(item.class)
            }, [
              _createElementVNode("th", _hoisted_16, _toDisplayString(item.key), 1),
              _createElementVNode("td", null, _toDisplayString(item.alu) + " €", 1),
              _createElementVNode("td", null, _toDisplayString(item.brass) + " €", 1),
              _createElementVNode("td", null, _toDisplayString(item.wood) + " €", 1)
            ], 2))
          }), 128))
        ])
      ])
    ])
  ]))
}